module.exports = __webpack_public_path__ + "static/DINWeb-f8df07a0857003759a5798eecfbd9324.woff";